import { DateRange } from "@angular/material/datepicker";
import { ISensor } from "../../common/models/sensor.interface";
import { ILoadableArray, Loadable, createDefaultILoadableArray, createDefaultLoadable } from "../../common/models/loadable";
import { ILoggedInUser } from "../../common/models";
import { IAlertBookmark } from "../models/alert-bookmark.model";
import { IInvestigatePopupState, initialInvestigatePopupState, IRecordingsPopupFilter } from "../../common/models/recordings-popup.model";

export const MEDIA_CONTROLS_KEY = "recordings_media_controls";
export const SHOW_UNSCHEDULED_CAMS = "recordings_show_unscheduled_cams";

export function loadMediaControls(user: ILoggedInUser): boolean {
    return JSON.parse(localStorage.getItem(`${user.id.slice(0, 6)}_${MEDIA_CONTROLS_KEY}`) ?? "true");
}

export function loadShowUnscheduledCams(user: ILoggedInUser): boolean {
    return JSON.parse(localStorage.getItem(`${user.id.slice(0, 6)}_${SHOW_UNSCHEDULED_CAMS}`) ?? "false");
}

export function storeMediaControls(user: ILoggedInUser, state: boolean) {
    localStorage.setItem(`${user.id.slice(0, 6)}_${MEDIA_CONTROLS_KEY}`, JSON.stringify(state))
}

export function storeShowUnscheduledCams(user: ILoggedInUser, state: boolean) {
    localStorage.setItem(`${user.id.slice(0, 6)}_${SHOW_UNSCHEDULED_CAMS}`, JSON.stringify(state))
}

export interface IRecording {
    id: string, // ID is CameraID
    name: string,
    url: string,
    organisation_id: string,
    retention_period: number,
    requested_daterange: DateRange<Date>
}

export interface ISiteRecordings {
    id: string,
    name: string,
    organisation_id: string,
    cameras: IRecording[]
}

export interface IRecordingState extends Loadable {
    recordings: ISiteRecordings[],
    selectedCameras: ISensor[],
    selectedDateRange: DateRange<Date> | undefined,
    durationInSecs: number,
    cameraRecordings: ILoadableArray<IRecording>,
    mediaControls: boolean,
    showUnscheduledCams: boolean,
    alertBookmarks: IAlertBookmark[],
    bookmarksEnabled: boolean,
    bookmarksLoading: boolean,
    // Opener side: the Investigate popup this window opened.
    investigatePopup: IInvestigatePopupState,
    // Popup side: a filter handed over by the opener, waiting to be applied.
    popupFilter: IRecordingsPopupFilter | null,
}

export const initialRecordingState: IRecordingState = {
    ...createDefaultLoadable(),
    recordings: [],
    selectedCameras: [],
    selectedDateRange: undefined,
    durationInSecs: 0,
    cameraRecordings: createDefaultILoadableArray<IRecording>(),
    mediaControls: true,
    showUnscheduledCams: false,
    alertBookmarks: [],
    bookmarksEnabled: true,
    bookmarksLoading: false,
    investigatePopup: initialInvestigatePopupState,
    popupFilter: null,
}
